/* unplugin-vue-components disabled */import { render } from "./warmRegion.vue?vue&type=template&id=9554d508&scoped=true"
import script from "./warmRegion.vue?vue&type=script&lang=js"
export * from "./warmRegion.vue?vue&type=script&lang=js"

import "./warmRegion.vue?vue&type=style&index=0&id=9554d508&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9554d508"]])

export default __exports__